import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderSelect} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
// import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import SaveIcon from '@mui/icons-material/Save';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import {CellType} from '@grapecity/wijmo.grid';
import CustomAccordion from '../../../molecules/Accordion.js';

// import {removeClass} from '@grapecity/wijmo';
// import {addClass} from '@grapecity/wijmo';

// import CheckCircle from '@mui/icons-material/CheckCircle';

const styles = (theme) => ({

});

// 一覧
const kenViews = [
  {header: '', dataType: 'header', elems: [
    {binding: 'nwKen', header: '県', dataType: 'String', width: 110, readOnly: true},
    {binding: 'mokuHyo', header: '目標', dataType: 'String', width: 62, readOnly: true},
    {binding: 'hiRitu', header: '比率', dataType: 'String', width: 48, readOnly: true},
  ]},
  {header: '2025年', dataType: 'header', elems: [
    {binding: 'itaku1Year1', header: '委託1', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku2Year1', header: '委託2', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku3Year1', header: '委託3', dataType: 'String', width: 75, readOnly: true, align: 'right'},
  ]},
  {header: '2026年', dataType: 'header', elems: [
    {binding: 'itaku1Year2', header: '委託1', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku2Year2', header: '委託2', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku3Year2', header: '委託3', dataType: 'String', width: 75, readOnly: true, align: 'right'},
  ]},
  {header: '2027年', dataType: 'header', elems: [
    {binding: 'itaku1Year3', header: '委託1', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku2Year3', header: '委託2', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku3Year3', header: '委託3', dataType: 'String', width: 75, readOnly: true, align: 'right'},
  ]},
  {header: '2028年', dataType: 'header', elems: [
    {binding: 'itaku1Year4', header: '委託1', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku2Year4', header: '委託2', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku3Year4', header: '委託3', dataType: 'String', width: 75, readOnly: true, align: 'right'},
  ]},
  {header: '合計', dataType: 'header', elems: [
    {binding: 'itaku1Total', header: '委託1', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku2Total', header: '委託2', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku3Total', header: '委託3', dataType: 'String', width: 75, readOnly: false, align: 'right'},
  ]},

];

// 目標調査件数設定
const nwcViews = [
  {header: '', dataType: 'header', elems: [
    {binding: 'nwJigyosyo', header: '旧NW事業所', dataType: 'String', width: 110, readOnly: true},
    {binding: 'mokuHyo', header: '目標', dataType: 'String', width: 62, readOnly: true},
    {binding: 'hiRitu', header: '比率', dataType: 'String', width: 48, readOnly: true},
  ]},
  {header: '2025年', dataType: 'header', elems: [
    {binding: 'itaku1Year1', header: '委託1', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku2Year1', header: '委託2', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku3Year1', header: '委託3', dataType: 'String', width: 75, readOnly: false, align: 'right'},
  ]},
  {header: '2026年', dataType: 'header', elems: [
    {binding: 'itaku1Year2', header: '委託1', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku2Year2', header: '委託2', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku3Year2', header: '委託3', dataType: 'String', width: 75, readOnly: false, align: 'right'},
  ]},
  {header: '2027年', dataType: 'header', elems: [
    {binding: 'itaku1Year3', header: '委託1', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku2Year3', header: '委託2', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku3Year3', header: '委託3', dataType: 'String', width: 75, readOnly: false, align: 'right'},
  ]},
  {header: '2028年', dataType: 'header', elems: [
    {binding: 'itaku1Year4', header: '委託1', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku2Year4', header: '委託2', dataType: 'String', width: 75, readOnly: false, align: 'right'},
    {binding: 'itaku3Year4', header: '委託3', dataType: 'String', width: 75, readOnly: false, align: 'right'},
  ]},
  {header: '合計', dataType: 'header', elems: [
    {binding: 'itaku1Total', header: '委託1', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku2Total', header: '委託2', dataType: 'String', width: 75, readOnly: true, align: 'right'},
    {binding: 'itaku3Total', header: '委託3', dataType: 'String', width: 75, readOnly: true, align: 'right'},
  ]},
];

/**
 * 目標調査件数設定画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // let _list = ['メニュー'];
    // _list.push(GMN.GOAL_INVEST_SETTING_LIST.name);
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.GOAL_INVEST_SETTING_LIST.name, href: ''},
    ];
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      // tabIndex: 1,
      transitionList: _list,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
    this.gridNwcRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
      this.props.doSetInitValues({tyousakikan: '5000'});
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
        direction={'row'}
      >
        <Grid key="tyousakikan" item xs={12} sm={2}>
          <Field
            id="tyousakikan"
            name="tyousakikan"
            // variant="standard"
            component={renderSelect}
            className={'fields'}
            label="県"
            fullWidth
            required={true}
            validate={[
            ]}
            InputProps={{
              readOnly: false,
            }}
          >
            <MenuItem value={2000}>{'鳥取県'}</MenuItem>
            <MenuItem value={3000}>{'島根県'}</MenuItem>
            <MenuItem value={4000}>{'岡山県'}</MenuItem>
            <MenuItem value={5000}>{'広島県'}</MenuItem>
            <MenuItem value={6000}>{'山口県'}</MenuItem>
          </Field>
        </Grid>
        <Grid key="zigyoujo" item xs={12} sm={2}>
          <Field
            id="zigyoujo"
            name=""
            // variant="standard"
            component={renderSelect}
            className={'fields'}
            label="NW事業所"
            fullWidth
            required={false}
            validate={[
            ]}
            InputProps={{
              readOnly: false,
            }}
          >
            <MenuItem value="">&nbsp;</MenuItem>
            <MenuItem value={5100}>{'広島'}</MenuItem>
            <MenuItem value={5110}>{'福山'}</MenuItem>
            <MenuItem value={5120}>{'尾道'}</MenuItem>
            <MenuItem value={5130}>{'三次'}</MenuItem>
            <MenuItem value={5140}>{'呉'}</MenuItem>
            <MenuItem value={5160}>{'広島北'}</MenuItem>
            <MenuItem value={5170}>{'廿日市'}</MenuItem>
            <MenuItem value={5190}>{'東広島'}</MenuItem>
            <MenuItem value={5250}>{'矢野'}</MenuItem>
          </Field>
        </Grid>
      </Grid>
    );
  };

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataKen =[
      {nwKen: '広島県', mokuHyo: '目標', hiRitu: '比率', itaku1Year1: '50%', itaku2Year1: '35%', itaku3Year1: '15%', itaku1Year2: '50%', itaku2Year2: '35%', itaku3Year2: '15%', itaku1Year3: '50%', itaku2Year3: '35%', itaku3Year3: '15%', itaku1Year4: '50%', itaku2Year4: '35%', itaku3Year4: '15%', itaku1Total: '50%', itaku2Total: '35%', itaku3Total: '15%', changeFlag: '1'},
      {nwKen: '広島県', mokuHyo: 'NWC集計値', hiRitu: '比率', itaku1Year1: '50%', itaku2Year1: '35%', itaku3Year1: '15%', itaku1Year2: '50%', itaku2Year2: '35%', itaku3Year2: '15%', itaku1Year3: '50%', itaku2Year3: '35%', itaku3Year3: '15%', itaku1Year4: '50%', itaku2Year4: '35%', itaku3Year4: '15%', itaku1Total: '50%', itaku2Total: '35%', itaku3Total: '15%'},
      {nwKen: '広島県', mokuHyo: 'NWC集計値', hiRitu: '口数', itaku1Year1: '30,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '30,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '30,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '30,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '120,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true'},
      {nwKen: '広島県', mokuHyo: 'NWC集計値', hiRitu: '口数', itaku1Year1: '15,000', itaku2Year1: '10,500', itaku3Year1: '4,500', itaku1Year2: '15,000', itaku2Year2: '10,500', itaku3Year2: '4,500', itaku1Year3: '15,000', itaku2Year3: '10,500', itaku3Year3: '4,500', itaku1Year4: '15,000', itaku2Year4: '10,500', itaku3Year4: '4,500', itaku1Total: '60,000', itaku2Total: '42,000', itaku3Total: '18,000'},
    ];
    const dataNwc =[
      {nwJigyosyo: '広島', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true'},
      {nwJigyosyo: '広島', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000'},
      {nwJigyosyo: '広島', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true'},
      {nwJigyosyo: '広島', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000', changeFlag: '1'},
      {nwJigyosyo: '広島', mokuHyo: '目標値', hiRitu: '比率', itaku1Year1: '50%', itaku2Year1: '35%', itaku3Year1: '15%', itaku1Year2: '50%', itaku2Year2: '35%', itaku3Year2: '15%', itaku1Year3: '50%', itaku2Year3: '35%', itaku3Year3: '15%', itaku1Year4: '50%', itaku2Year4: '35%', itaku3Year4: '15%', itaku1Total: '50%', itaku2Total: '35%', itaku3Total: '15%'},

      {nwJigyosyo: '廿日市', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true', separator: 'true'},
      {nwJigyosyo: '廿日市', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000'},
      {nwJigyosyo: '廿日市', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true'},
      {nwJigyosyo: '廿日市', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000', changeFlag: '1'},
      {nwJigyosyo: '廿日市', mokuHyo: '目標値', hiRitu: '比率', itaku1Year1: '50%', itaku2Year1: '35%', itaku3Year1: '15%', itaku1Year2: '50%', itaku2Year2: '35%', itaku3Year2: '15%', itaku1Year3: '50%', itaku2Year3: '35%', itaku3Year3: '15%', itaku1Year4: '50%', itaku2Year4: '35%', itaku3Year4: '15%', itaku1Total: '50%', itaku2Total: '35%', itaku3Total: '15%'},

      {nwJigyosyo: '広島北', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true', separator: 'true'},
      {nwJigyosyo: '広島北', mokuHyo: '参考値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000'},
      {nwJigyosyo: '広島北', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '10,000', itaku2Year1: '', itaku3Year1: '', itaku1Year2: '10,000', itaku2Year2: '', itaku3Year2: '', itaku1Year3: '10,000', itaku2Year3: '', itaku3Year3: '', itaku1Year4: '10,000', itaku2Year4: '', itaku3Year4: '', itaku1Total: '40,000', itaku2Total: '', itaku3Total: '', yearMerge: 'true'},
      {nwJigyosyo: '広島北', mokuHyo: '目標値', hiRitu: '口数', itaku1Year1: '5,000', itaku2Year1: '3,500', itaku3Year1: '1,500', itaku1Year2: '5,000', itaku2Year2: '3,500', itaku3Year2: '1,500', itaku1Year3: '5,000', itaku2Year3: '3,500', itaku3Year3: '1,500', itaku1Year4: '5,000', itaku2Year4: '3,500', itaku3Year4: '1,500', itaku1Total: '20,000', itaku2Total: '14,000', itaku3Total: '6,000', changeFlag: '1'},
      {nwJigyosyo: '広島北', mokuHyo: '目標値', hiRitu: '比率', itaku1Year1: '50%', itaku2Year1: '35%', itaku3Year1: '15%', itaku1Year2: '50%', itaku2Year2: '35%', itaku3Year2: '15%', itaku1Year3: '50%', itaku2Year3: '35%', itaku3Year3: '15%', itaku1Year4: '50%', itaku2Year4: '35%', itaku3Year4: '15%', itaku1Total: '50%', itaku2Total: '35%', itaku3Total: '15%'},
    ];

    this.gridRef.current.setItemsSource(dataKen);
    this.gridNwcRef.current.setItemsSource(dataNwc);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    this.gridNwcRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 表示ボタン押下時
   */
  doDisplayInfo = async () => {
    this.props.navigate(GMN_PATH.CUSTOMER_SECURITY_INFO);
  };

  /**
   * 新規作成ボタン押下時
   */
  doTenNext = async () => {
    try {
      // const {generalPurposeMap} = this.props;
      // this.props.doSetOrderId(null);
      // this.props.doSetOrderModifiedCondition(null, null);
      // this.props.doClearOrderInfo(); // 前回データをクリア
      // this.props.doSetStbType(getCodeFromGeneralPurposeMap(generalPurposeMap, 'StbType2', 1));
      // this.props.history.push({pathname: '/TenProprietyBasicInfo'});
      let params = {
        // surveyYear,
        mod: 'I',
      };
      // 目標調査件数設定画面に遷移
      setSessionObject(GMN.ANNUAL_SURVERY_PLAN_INFO.id, params);
      this.props.navigate(GMN_PATH.ANNUAL_SURVERY_PLAN_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
 * 承認状況画面を閉じる
 */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };
  /**
   * 否認画面の表示
   */
  displayApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: true,
    });
  };

  /**
 * 否認画面を閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doUpdate = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000006C',
        values: ['目標調査件数', '更新'],
      },
    });
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    if (view.dataType === 'CellMaker') {
      if (view.binding === 'tskkJgyosyo') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.doEditLink(ctx.item.tskkJgyosyo, ctx.item.sinnseiStatus);
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      } else if (view.binding === 'sinnseiStatus') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.displayApproval();
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      }
    }

    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}
      align={view.align}/>;
  };

  /**
   * セル結合をカスタム
   * @param {object} wjgGrid wijmo.grid モジュール
   * @param {object} panel 範囲を含むGridPanel
   * @param {number} r セルが含まれる行のインデックス
   * @param {number} c セルが含まれる列のインデックス
   * @param {boolan} clip 結合範囲をグリッドの現在のビュー範囲にクリップするかどうか
   * @return {*} 結合範囲を指定するCellRange
   */
  mergedRange = (wjgGrid, panel, r, c, clip = true) => {
    let rng = new wjgGrid.CellRange(r, c);

    if (panel.cellType == CellType.ColumnHeader) {
      if (r == 0) {
        rng.col = c - (c % 3);
        rng.col2 = rng.col + 2;
        return rng;
      }
      if (r == 1 && ['mokuHyo', 'hiRitu'].includes(panel.columns.at(c).binding)) {
        rng.col = 1;
        rng.col2 = 2;
        return rng;
      }
    }

    if (panel.cellType == CellType.Cell) {
      if (c < 3) {
        let pcol = c > 0 ? c - 1 : c;
        let pval = panel.getCellData(r, pcol, false);
        let val = panel.getCellData(r, c, false);

        // 縦結合（up）※現行と前行の列が一致
        while (rng.row > 0 &&
          panel.getCellData(rng.row - 1, c, false) == val &&
          panel.getCellData(rng.row - 1, pcol, false) == pval) {
          rng.row--;
        }
        // 縦結合（down）※現行と前行のが一致
        while (rng.row2 < panel.rows.length - 1 &&
          panel.getCellData(rng.row2 + 1, c, false) == val &&
          panel.getCellData(rng.row2 + 1, pcol, false) == pval) {
          rng.row2++;
        }
      } else {
        const data = panel.rows[r].dataItem;
        if (data.yearMerge) {
          rng.col = c - (c % 3);
          rng.col2 = rng.col + 2;
        }
      }
    }
    return rng;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemKenFunction = (s, e) => {
  // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType == CellType.Cell) {
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;
      const totalBindings = ['itaku1Total', 'itaku2Total', 'itaku3Total'];

      //
      if (col.binding === 'mokuHyo') {
        e.cell.style['white-space'] = 'normal';
      }

      // 合計の目標比率ではない場合、CellをReadOnlyに設定する
      if (col && data.changeFlag !== '1' && totalBindings.includes(col.binding)) {
        e.cell.innerHTML = '<div >'+data[col.binding]+'</div>';
      }

      // 合計の目標比率編集可能のため、Cellに色付ける
      if (col && data.changeFlag === '1' && totalBindings.includes(col.binding)) {
        // e.cell.style.backgroundColor = 'lightyellow';
        e.cell.style.backgroundColor = '#e8f9ff';
        e.cell.style.borderRadius = '4px';
        e.cell.style.boxShadow = '#0085c7 1px 1px 1px 0px inset';
        e.cell.style.color = 'black';
      } else {
        if (e.col >= 3 && data.yearMerge) {
          e.cell.style['text-align'] = 'center';
        }
        e.cell.style.backgroundColor = '#f7f7f7';
        e.cell.style.color = 'black';
      }
    }
  };


  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemNwcFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }
    if (e.panel.cellType != CellType.Cell) {
      return;
    }

    const col = e.getColumn();
    const data = s.rows[e.row].dataItem;
    const yearBindings = [
      'itaku1Year1', 'itaku2Year1', 'itaku3Year1', 'itaku1Year2', 'itaku2Year2', 'itaku3Year2',
      'itaku1Year3', 'itaku2Year3', 'itaku3Year3', 'itaku1Year4', 'itaku2Year4', 'itaku3Year4',
    ];

    // 各年度の調整値(口数)以外の場合、CellをReadOnlyに設定する
    if (col && data.changeFlag !== '1' && yearBindings.includes(col.binding)) {
      e.cell.innerHTML = '<div >'+data[col.binding]+'</div>';
    }

    // 各年度の調整値(口数)編集可能のため、Cellに色付ける
    if (col && data.changeFlag === '1' && yearBindings.includes(col.binding)) {
      // e.cell.style.backgroundColor = 'lightyellow';
      e.cell.style.backgroundColor = '#e8f9ff';
      e.cell.style.borderRadius = '4px';
      e.cell.style.boxShadow = '#0085c7 1px 1px 1px 0px inset';
      e.cell.style.color = 'black';
    } else {
      if (e.col >= 3 && data.yearMerge) {
        e.cell.style['text-align'] = 'center';
      }
      e.cell.style.backgroundColor = '#f7f7f7';
      e.cell.style.color = 'black';
    }
    if (data.separator) {
      e.cell.style['border-top-width'] = '3px';
      e.cell.style['border-top-style'] = 'double';
    }
  };

  /**
   * 県一覧表示
   * @return {object}
   */
  renderTableKen() {
    const props = {
      headersVisibility: 'Column',
      allowDragging: 'None',
      frozenColumns: 3,
      style: {maxHeight: 'auto', maxWidth: '100%', height: 'auto', width: 'auto', marginTop: '0px', marginLeft: '8px'},
      checkedFunction: this.checkStateUpdate,
      customMergedRange: this.mergedRange,
      formatItemFunction: this.formatItemKenFunction,
    };

    let viewElems = [];
    if (kenViews) {
      for (const view of kenViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * NWC一覧描画
   * @return {*}
   */
  renderTableNwc() {
    const props = {
      headersVisibility: 'Column',
      allowDragging: 'None',
      frozenColumns: 3,
      style: {maxHeight: 'auto', maxWidth: '100%', height: 'auto', width: 'auto', marginTop: '0px', marginLeft: '8px'},
      checkedFunction: this.checkStateUpdate,
      customMergedRange: this.mergedRange,
      formatItemFunction: this.formatItemNwcFunction,
    };

    let viewElems = [];
    if (nwcViews) {
      for (const view of nwcViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }
    return (
      // <CustomFlexGrid frozenRows={1} ref={this.gridRef} {...props}>
      <CustomFlexGrid ref={this.gridNwcRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 一覧リンククリック時
   * @param {*} tskkJgyosyo 調査機関事業所
   * @param {*} sinnseiStatus ステータス
   */
  doEditLink = async (tskkJgyosyo, sinnseiStatus) => {
    try {
      let params = {
        tskkJgyosyo,
        mod: 'C',
      };
      if (sinnseiStatus =='作成中' || sinnseiStatus =='取止済') {
        params = {
          tskkJgyosyo,
          mod: 'C',
        };
      } else if (sinnseiStatus =='工組承認待ち'|| sinnseiStatus =='申請内容確認中'|| sinnseiStatus =='NWC承認待ち') {
        params = {
          tskkJgyosyo,
          // mod: 'U',
          mod: 'C',
        };
      } else if (sinnseiStatus =='完了') {
        params = {
          tskkJgyosyo,
          // mod: 'W',
          mod: 'C',
        };
      } else {
        params = {
          tskkJgyosyo,
          mod: 'C',
        };
      }

      // 目標調査件数設定画面に遷移
      setSessionObject(GMN.ANNUAL_SURVERY_PLAN_INFO.id, params);
      this.props.navigate(GMN_PATH.ANNUAL_SURVERY_PLAN_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-end"
        spacing={1}
      >
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={this.doUpdate}
            // size="large"
          >
            <span>更新</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            // onClick={this.doApprove}
            variant="contained"
            // startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>委託エリア設定</span>
          </PositiveButton>
        </Grid>
        <Grid key="aggregate" item>
          <PositiveButton
            id="aggregate"
            variant="contained"
            // startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>目標口数集計</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-end"
            spacing={1}
            direction={'row'}
          >
            {this.renderTableKen()}
          </Grid>

          <div style={{marginBottom: '0px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-end"
            spacing={1}
            direction={'row'}
          >
            {this.renderTableNwc()}
          </Grid>
          {/*
          <PaperPart>
            <Grid key="keySCA1002HenkomaeTable" item xs={12}>
              <div style={{marginTop: '0px', marginBottom: '0px', marginLeft: '0px', marginRight: '0px'}}>
                {this.renderTableNwc()}
              </div>
            </Grid>

          </PaperPart> */}

        </MainContainer>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    // initialValues: {
    //   dntNo1: '123',
    //   dntNo2: '456',
    //   dntNo3: '789',
    //   hikikomiDnt: '123',
    //   keiyakuNo1: '',
    //   jigyousyo: '456',
    //   states: '2',
    // },
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

